import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const professionalregister = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/miscellaneous/{profile}/professional-register',
    app: 'miscellaneous'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'miscellaneous', model: 'professionalregister' }
    ),
    { }
  )
)()

export { professionalregister, TYPES }
